// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".transit-order-summary .v6-content{height:calc(100dvh - 80px)}", "",{"version":3,"sources":["webpack://./pos/app/scripts/components/transit-order-summary/transit-order-summary.scss"],"names":[],"mappings":"AACE,mCACE,0BAAA","sourcesContent":[".transit-order-summary {\n  .v6-content {\n    height: calc(100dvh - 80px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
